export const advisorOptions = state => state.options.advisor
export const advisorOptionsDone = state => state.options.advisorDone
export const changePassword = state => state.topbar.changePassword
export const errors = state => state.topbar.errors
export const feedback = state => state.topbar.feedback
export const pendings = state => state.topbar.pendings
export const settings = state => state.topbar.settings
export const user = state => state.auth.user
